import Validator from '../../validator';
import {
  phoneMustBeTenDigits,
  zipCodeMustBeFiveDigits,
} from '../../validationUtils';

const MailingAddressChangeValidator = new Validator([
  {
    field: 'effDate',
    method: 'isEmpty',
    validWhen: false,
    message: 'Effective Date is required.',
  },
  {
    field: 'streetAddr',
    method: 'isEmpty',
    validWhen: false,
    message: 'Street Address is required.',
  },
  {
    field: 'city',
    method: 'isEmpty',
    validWhen: false,
    message: 'City is required.',
  },
  {
    field: 'zip',
    method: 'isEmpty',
    validWhen: false,
    message: 'Zip Code is required.',
  },
  {
    field: 'zip',
    method: zipCodeMustBeFiveDigits,
    validWhen: true,
    message: 'Zip Code must be five digits.',
  },
  {
    field: 'phone',
    method: 'isEmpty',
    validWhen: false,
    message: 'Primary Phone is required.',
  },
  {
    field: 'phone',
    method: phoneMustBeTenDigits,
    validWhen: true,
    message: 'Primary Phone must be ten digits.',
  },
  {
    field: 'file',
    method: 'isEmpty',
    validWhen: false,
    message: 'Request signed by the Insured is required.',
  },
]);

export default MailingAddressChangeValidator;
